module.exports = __webpack_public_path__ + "static/accident_new-00230f4a152e1635394521867acd6d70.svg";